
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
components:{
XHeader,
},
data(){
return{
model:{},
initModel:{}
}
},
created(){
this.getData(this.$route.query.videoId)
},
methods: {
getData(videoId){

this.model.videoId=videoId
this.$http.post(this.global.httpUrl + '/rest/v1/m/mlearn/getVideoDetail',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.initModel= res.body.data
console.log(this.initModel)
}
},function(res){
});
}
}
}



// WEBPACK FOOTER //
// ./src/views/learn/productDetail.vue